import { Html } from '@react-three/drei';
import { useRef } from 'react';

interface InfoPanelProps {
  position: [number, number, number];
  info: {
    title: string;
    description: string;
    metrics: {
      name: string;
      value: string;
      status?: 'normal' | 'warning' | 'critical';
    }[];
  };
  onClose: () => void;
}

export function InfoPanel({ position, info, onClose }: InfoPanelProps) {
  const { title, description, metrics } = info;
  const panelRef = useRef<HTMLDivElement>(null);

  return (
    <Html position={position} center transform occlude>
      <div
        ref={panelRef}
        className="bg-background/90 backdrop-blur-md border border-border p-4 rounded-lg shadow-lg w-[280px]"
        style={{ pointerEvents: 'auto' }}
      >
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-base font-bold">{title}</h3>
          <button className="text-muted-foreground hover:text-foreground text-xs" onClick={onClose}>
            ✕
          </button>
        </div>

        <p className="text-xs text-muted-foreground mb-3">{description}</p>

        <div className="space-y-2">
          {metrics.map((metric, index) => (
            <div key={index} className="flex justify-between items-center">
              <span className="text-xs font-medium">{metric.name}</span>
              <span
                className={`text-xs font-bold ${
                  metric.status === 'critical'
                    ? 'text-red-500'
                    : metric.status === 'warning'
                      ? 'text-amber-500'
                      : 'text-green-500'
                }`}
              >
                {metric.value}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-4 pt-2 border-t border-border text-xs text-center text-muted-foreground">
          Click and drag to rotate • Scroll to zoom
        </div>
      </div>
    </Html>
  );
}
